import { app } from '../../../bootstrap/core';
import { needsConfirmation } from './needsConfirmation.directive';
import { NeedsConfirmationService } from './needsConfirmation.service';
import './confirmation.tpl.html';

app.directive('needsConfirmation', needsConfirmation);
app.service('needsConfirmationService', NeedsConfirmationService);
